var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grarantee-form-contanier"},[_c('Nav',{attrs:{"applyType":"9100"}}),_c('Step',{staticClass:"mb-6",attrs:{"arr":_vm.arr}}),_c(_vm.stepComnent,{tag:"component",on:{"updateStepStatus":_vm.updateStepStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }